import { render, staticRenderFns } from "./CompanyWrapper.vue?vue&type=template&id=02eb9196"
import script from "./CompanyWrapper.vue?vue&type=script&lang=ts"
export * from "./CompanyWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports